import api from '@/api';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
import {
  EmployeeComissionCreateRequest,
  EmployeeCommission,
  EmployeeCommissionCreateResponse,
  EmployeeCommissionListRequest,
} from './EmployeeCommission.types';

const CONTROLLER_URL = `${API_BASE_URL}/employee-commission`;

export async function listEmployeeCommission(
  params: EmployeeCommissionListRequest,
) {
  const result = (await api.get(CONTROLLER_URL, params)) as unknown;

  return result as PageResult<EmployeeCommission>;
}

export async function createEmployeeCommission(
  data: EmployeeComissionCreateRequest,
) {
  const result = (await api.post(CONTROLLER_URL, data)) as unknown;

  return result as EmployeeCommissionCreateResponse;
}

export async function removeEmployeeCommission(id: number) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${id}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
